import React, { useRef } from 'react';
import block from 'propmods';
import i18n from '@yandex-int/i18n';
import { UnmanagedConfirm, Handles } from '../../Confirm/UnmanagedConfirm';
import * as keysetCommon from 'i18n/Common';
import * as keyset from 'i18n/Settings';

import RecycleBinIcon from '../../../assets/bin.svg';

import './LanguageDeleteButton.scss';

const b = block('LanguageDeleteButton');
const t = i18n(keyset);
const tCommon = i18n(keysetCommon);

interface Props {
    onClick: () => void;
    disabled: boolean;
}

export const LanguageDeleteButton: React.FC<Props> = ({ onClick, disabled }) => {
    const confirmRef = useRef<Handles>(null);
    const onRemoveLanguage = () => {
        confirmRef.current?.open({
            title: t('header-delete-language'),
            description: (
                <>
                    <p {...b('p')}>{t('description-delete-language-one')}</p>
                    <p {...b('p')}>{t('description-delete-language-two')}</p>
                </>
            ),
            onConfirm: onClick,
            confirmText: tCommon('button-delete'),
            rejectText: tCommon('button-not-required'),
        });
    };

    if (disabled) return null;

    return (
        <>
            <button {...b('button')} disabled={disabled} onClick={onRemoveLanguage}>
                <RecycleBinIcon />
            </button>
            <UnmanagedConfirm ref={confirmRef} />
        </>
    );
};
